/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';

/**
 * Header Context Type Definition
 */

export type HeaderContextType = {
  isMobileMenuOpen: boolean;
  toggleMobileMenu: () => void;
};

/**
 * Header Context Definition
 */

const HeaderContext = createContext<HeaderContextType>({
  isMobileMenuOpen: false,
  toggleMobileMenu: () => {},
});

export default HeaderContext;
